import { priceTypeLabel, priceTypeModifier } from "./priceType";
import "../../css/PriceTypeBadge.css";

/**
 * 구독 결제 유형 배지 (정상가 · 50% 할인 · 100원 혜택) + 실제 결제 금액.
 * 결제 유형이 없으면(무료 회원·서버 미제공) "-".
 */
function PriceTypeBadge({ priceType, paidAmount }) {
  const label = priceTypeLabel(priceType);
  if (!label) return <span className="price-type-empty">-</span>;

  return (
    <span className="price-type-cell">
      <span className={`price-type-badge price-type-badge--${priceTypeModifier(priceType)}`}>{label}</span>
      {paidAmount != null && (
        <span className="price-type-amount">{Number(paidAmount).toLocaleString("ko-KR")}원</span>
      )}
    </span>
  );
}

export default PriceTypeBadge;
